import { useEffect, useState } from "react";
import VisitClient from "./visit-client";
import VisitClientAdd from "./visit-client-add";
import { serverFetch } from "../../server";
import { Button, message, Popconfirm, Space, Spin, Select, Tooltip, Input, InputNumber } from "antd";
import VisitCnt from "./visit-cnt";
import SaleAdd from "../sales/sale-add";
import { PaymentAdd } from "../payments";
import { CloseOutlined, WarningOutlined } from "@ant-design/icons";
import { isMobile } from "../../extensions/design";
import { LogMonitor } from "@/controls";
import ButtonReport from "../../controls/button-report/button-report";
import { dictsGetPaymentVids } from "../../extensions/dicts";


const VisitBody = ({ id, onClose, onRefresh }) => {
  const [item, setItem] = useState();
  const [loading, setLoading] = useState(false);
  const [saleAdd, setSaleAdd] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [canBeDeleted, setCanBeDeleted] = useState(false);
  const [page, setPage] = useState(0);
  const [clientName, setClientName] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [vidPayments, setVidPayments] = useState([]);
  const [hasNonZeroDeposit, setHasNonZeroDeposit] = useState(false);
  // Группа клиента - для переключения между членами группы
  const [familyList, setFamilyList] = useState([]);
  // Представитель группы (корень группы)
  const [familyRootId, setFamilyRootId] = useState(null);
  // Модалка создания визита для следующего участника группы
  const [addAnotherOpen, setAddAnotherOpen] = useState(false);
  const [addAnotherClientId, setAddAnotherClientId] = useState(null);
  // Есть ли участник группы без открытого визита
  const [hasAvailableAnother, setHasAvailableAnother] = useState(false);

  const getData = (calcPenalty) => {
    setLoading(true);
    const penaltyReady = calcPenalty
      ? serverFetch(`visit/Penalty/${id}`, { method: "PUT" }).catch(e => {
          message.error(e.userMessage);
        })
      : Promise.resolve();

    penaltyReady
      .then(() => serverFetch(`visit/${id}`))
      .then(data => {
        setItem(data);
        setLoading(false);
        if (data?.clientId) {
          serverFetch(`client/${data.clientId}`)
            .then(clientData => {
              setClientName(clientData?.name || "");
            })
            .catch(() => {});
        }
      })
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      });

    serverFetch(`visit/CanBeDeleted/${id}`)
      .then(data => setCanBeDeleted(data))
      .catch(e => message.error(e.userMessage));
  }

  useEffect(() => { getData(true); }, [id]);

  useEffect(() => { dictsGetPaymentVids(data => setVidPayments(data)); }, []);

  useEffect(() => { console.log(accounts) }, [accounts]); 

  useEffect(() => {
    if (item?.clientId) {
      serverFetch(`payment/accounts/client/${item.clientId}`)
        .then(data => setAccounts(data))
        .catch(e => message.error(e.userMessage));
    }
  }, [item?.clientId]);

  // Загружаем группу клиента для отображения селектора участников группы в карточке клиента
  useEffect(() => {
    if (!item?.clientId) {
      setFamilyList([]);
      setFamilyRootId(null);
      return;
    }
    serverFetch(`client/${item.clientId}`)
      .then((client) => {
        const rootId = client?.representativeId || client.id;
        return serverFetch(`client/${rootId}/family`)
          .then((children) => ({ rootId, client, children: Array.isArray(children) ? children : [] }));
      })
      .then(({ rootId, client, children }) => {
        if (rootId === client.id) {
          setFamilyRootId(rootId);
          setFamilyList([client, ...children]);
          return;
        }
        // Корень - представитель, добавляем и его данные в список
        return serverFetch(`client/${rootId}`)
          .then((root) => {
            setFamilyRootId(rootId);
            setFamilyList([root, ...children]);
          });
      })
      .catch(() => {
        setFamilyRootId(null);
        setFamilyList([]);
      });
  }, [item?.clientId]);

  const onCloseVisit = () => {
    setLoading(true);
    serverFetch(`visit/finish/${id}`, {method: "PUT"} )
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  // }
  }

  const onSaleAdd = () => {
    setSaleAdd(true);
  }

  const onCloseSaleAdd = (refresh) => {
    setSaleAdd(false);
    refresh && onContentRefresh();
  }

  const onClosePayment = (refresh) => {
    setShowPayment(false);
    refresh && onContentRefresh();
  }

  const onCloseAddAnother = (refresh, visitId) => {
    setAddAnotherOpen(false);
    setAddAnotherClientId(null);
    if (visitId) {
      onClose(true, visitId);
    } else if (refresh) {
      onContentRefresh();
    }
  }

  const onContentRefresh = () => {
    getData(false);
    onRefresh();
  }

  const onDelete = () => {
    setLoading(true);
    serverFetch(`visit/${id}`, { method: "DELETE" })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const onUnclose = () => {
    setLoading(true);
    serverFetch(`visit/unfinish/${id}`, { method: "PUT" })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const canClose = !item?.dolg || item?.clientId;
  const blockByDeposit = hasNonZeroDeposit && !item?.clientId;

  const closeMsg = item?.dolg ? "Закрыть визит с долгом?" : "Закрыть визит?";

  const onCloseClient = (refresh) => {
    onRefresh();
    getData();
  }

  // Открыть визит для следующего участника группы, у которого нет открытого визита
  const onOpenAnother = () => {
    if (!familyList || familyList.length <= 1) return;
    const currentId = item?.clientId;
    const candidates = familyList.filter(c => c && c.id !== currentId);
    const checkNext = (index = 0) => {
      if (index >= candidates.length) return;
      const candidate = candidates[index];
      serverFetch(`visit/Client/${candidate.id}?isOpen=true`)
        .then(visits => {
          const openVisit = Array.isArray(visits) ? visits.find(v => !v.finish) : null;
          if (!openVisit) {
            setAddAnotherClientId(candidate.id);
            setAddAnotherOpen(true);
          } else {
            checkNext(index + 1);
          }
        })
        .catch(() => checkNext(index + 1));
    };
    checkNext();
  };

  // Проверяем, есть ли участник группы без открытого визита (для состояния кнопки "Открыть ещё")
  useEffect(() => {
    if (!familyList || familyList.length <= 1) {
      setHasAvailableAnother(false);
      return;
    }
    const currentId = item?.clientId;
    const candidates = familyList.filter(c => c && c.id !== currentId);
    const checkNext = (index = 0) => {
      if (index >= candidates.length) {
        setHasAvailableAnother(false);
        return;
      }
      const candidate = candidates[index];
      serverFetch(`visit/Client/${candidate.id}?isOpen=true`)
        .then(visits => {
          const openVisit = Array.isArray(visits) ? visits.find(v => !v.finish) : null;
          if (!openVisit) {
            setHasAvailableAnother(true);
          } else {
            checkNext(index + 1);
          }
        })
        .catch(() => checkNext(index + 1));
    };
    checkNext();
  }, [familyList, item?.clientId]);

  const tabsConfig = [
    { key: "0", label: "Продажи" },
    { key: "1", label: "Абонементы" },
    { key: "2", label: "Пакеты" },
  ];
  
  const divClient = 
    <>
      {!isMobile ? <div className="sport-modal-title">
        <span>Визит</span>
        <CloseOutlined className="sport-section-title-close" onClick={onClose} style={{ zIndex: 9 }}   />
      </div> : <></>}
      {loading ? <Spin /> : item && item.clientId && <VisitClient id={item?.clientId} family={familyList} onOpenAnother={onOpenAnother} hasAvailableAnother={hasAvailableAnother} onSaleAdd={onSaleAdd} onRefresh={onCloseClient} onCloseVisit={onCloseVisit} onClose={onClose} />}
    </>
  
  const divVisitBody =
    <>
      {loading ? <Spin /> : item && <VisitCnt item={item} onRefresh={onContentRefresh} page={page} setPage={setPage} onHasNonZeroDepositChange={setHasNonZeroDeposit}/>}
    </>
  const divBtns = isMobile ? 
    <>
      {loading ? (<Spin />) : item ? (
        <div className="div-btns-visit">
          {familyList && familyList.length > 1 && (
            <Button onClick={onOpenAnother} disabled={!hasAvailableAnother} className="visit-body-mobile-btn" style={{ width: "100%", flexBasis: "100%" }}>Открыть ещё</Button>
          )}
          {item.dolg > 0 && (
            <Button onClick={() => setShowPayment(true)} className="visit-body-mobile-btn-pay"> Оплата {item.dolg} </Button>
          )}
          <Popconfirm title="Подтверждение" description="Удалить визит?" onConfirm={onDelete}
            placement="top" getPopupContainer={(trigger) => trigger.closest('.div-btns-visit')} overlayClassName="centered-popconfirm">
            <Button disabled={!canBeDeleted || item?.finish} className="visit-body-mobile-btn"> Удалить </Button>
          </Popconfirm>

          {item?.finish ? (
            <Popconfirm title="Подтверждение" description="Отменить закрытие?" onConfirm={onUnclose}
              placement="top" getPopupContainer={(trigger) => trigger.closest('.div-btns-visit')} overlayClassName="centered-popconfirm">
              <Button className="visit-body-mobile-btn" disabled={!item?.finish}>Отмен. закр.</Button>
            </Popconfirm>
          ) : (
            <Popconfirm title="Подтверждение" description={closeMsg} onConfirm={onCloseVisit}
              placement="top" getPopupContainer={(trigger) => trigger.closest('.div-btns-visit')} overlayClassName="centered-popconfirm">
              <Button className="visit-body-mobile-btn" disabled={!canClose || item?.finish}>Закрыть</Button>
            </Popconfirm>
          )}
        </div>
      ) : null}
    </> : <>
      {loading ? <Spin /> : item && <div className="">
        <Space>
          {item.dolg ? <Button onClick={() => setShowPayment(true)} className="dolg-button">Оплатить {item.dolg}</Button> : null}
          {/* <Button onClick={onSaleAdd} disabled={item?.finish}>Продать</Button> */}
          <Popconfirm title="Подтверждение" description="Удалить визит?" onConfirm={onDelete}>
            <Button disabled={!canBeDeleted || item?.finish}>Удалить визит</Button>
          </Popconfirm>
          <Tooltip title={blockByDeposit ? "Закрытие визита с ненулевым балансом депозита невозможно, произведите возврат" : null} placement="bottom">
            <span>
              <Popconfirm title="Подтверждение" description={closeMsg} onConfirm={onCloseVisit} disabled={blockByDeposit || !canClose || item?.finish}>
                <Button disabled={!canClose || item?.finish || blockByDeposit} icon={blockByDeposit ? <WarningOutlined /> : null}>Закрыть визит</Button>
              </Popconfirm>
            </span>
          </Tooltip>
          <Popconfirm title="Подтверждение" description="Отменить закрытие?" onConfirm={onUnclose}>
            <Button disabled={!item?.finish}>Отменить закрытие</Button>
          </Popconfirm>
          <LogMonitor vid={3} id={id}/>
        </Space>
      </div>}
    </>
  

  return <div className="sport-modal">
    <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
      <div className={isMobile ? "sport-modal-content mobile-content" : "sport-modal-content"} style={isMobile ? { width: 900 } : { width: 900 }} onMouseDown={e => e.stopPropagation()}>
        {isMobile ? (
          <>
            <div className="sport-modal-title-client" style={{ marginBottom: "6px"}}>
              <span>Визит</span>
              <Select 
                className="mobile-tabs-select" 
                value={String(page)} 
                onChange={(value) => setPage(Number(value))} 
                style={{ width: "65%", marginBottom: "2px" }}
              >
                {tabsConfig.map(({ key, label }) => (
                  <Select.Option key={key} value={key}>
                    {label}
                  </Select.Option>
                ))}
              </Select>
              <ButtonReport vid={3} id={item?.id} iconOnly={true} />
              <CloseOutlined className="sport-section-title-close" onClick={onClose} style={{ zIndex: 9, marginLeft: "auto", cursor: "pointer" }}/>
            </div>
            {divClient}
            {divVisitBody}
            {divBtns}
            {saleAdd && <SaleAdd visitId={id} clientId={item?.clientId} onClose={onCloseSaleAdd} />}
            {addAnotherOpen && <VisitClientAdd onClose={onCloseAddAnother} defaultClientId={addAnotherClientId} />}
            {showPayment && <PaymentAdd clientId={item?.clientId} visitId={id} onClose={onClosePayment} />}
          </>
        ) : (
          <>
            {divClient}
            {divVisitBody}
            {divBtns}
            {saleAdd && <SaleAdd visitId={id} clientId={item?.clientId} onClose={onCloseSaleAdd} />}
            {addAnotherOpen && <VisitClientAdd onClose={onCloseAddAnother} defaultClientId={addAnotherClientId} />}
            {showPayment && <PaymentAdd clientId={item?.clientId} visitId={id} onClose={onClosePayment} />}
          </>
        )}
      </div>
    </div>
  </div>
}

export default VisitBody;
